export const NETWORK_CONFIG = {
  chainId: 77177,
  chainIdHex: "0x12d79",
  chainName: "FMI Smart Chain",
  nativeCurrency: {
    name: "FMI",
    symbol: "FMI",
    decimals: 18,
  },
  // Same-origin: on a custom domain (e.g. fmismartchain.com) wallets get that domain's RPC
  rpcUrls: [`${window.location.origin}/api/rpc`],
  blockExplorerUrls: [window.location.origin],
  faucetUrl: `${window.location.origin}/faucet`,
};

export const LOGO_URL = "/fmi-logo.png?v=2";

export const TOKENS = [
  { symbol: "FMI", name: "FMI", decimals: 18, logo: LOGO_URL },
  { symbol: "USDT", name: "USDT Test Token (not Tether)", decimals: 18, logo: null },
  { symbol: "ETH", name: "Ethereum", decimals: 18, logo: null },
  { symbol: "BNB", name: "BNB", decimals: 18, logo: null },
];
